var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "coupon"
  }, [_c('div', {
    staticClass: "coupon--header"
  }, [_vm.displayName ? _c('div', {
    staticClass: "s-px-3 s-text-2xl s-font-bold text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.displayName) + " ")]) : _vm._e(), _c('div', {
    staticClass: "s-mt-2"
  }, [_c('p', [_vm._v(_vm._s(_vm.usagePeriodTitle) + "：")]), _c('time', [_vm._v(" " + _vm._s(_vm.startToEnd))])])]), _c('div', {
    staticClass: "coupon--wrapper"
  }, [_c('div', {
    staticClass: "coupon--image"
  }, [_vm.displayImage ? _c('img', {
    attrs: {
      "src": _vm.displayImage
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "coupon--body"
  }, [_vm.isShowBarcode && _vm.couponModel.isRedeemable ? _c('div', {
    staticClass: "coupon--barcode s-mb-4"
  }, [_vm.showBarcodeError ? _c('p', {
    staticClass: "s-text-danger"
  }, [_vm._v(" barcode 產生錯誤，請聯絡相關人員 ")]) : _c('img', {
    attrs: {
      "id": _vm.barcodeImgId,
      "src": require("@/pages/Dashboard/Coupon/barcode.png")
    }
  })]) : _vm._e(), _vm.showCode && _vm.coupon.code && !_vm.isHideCode && _vm.couponModel.isRedeemable ? _c('div', {
    staticClass: "coupon--copy-panel"
  }, [_c('span', {
    staticClass: "coupon--barcode"
  }, [_vm._v(" " + _vm._s(_vm.coupon.code) + " ")]), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.coupon.code,
      expression: "coupon.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.clipboardSuccessHandler,
      expression: "clipboardSuccessHandler",
      arg: "success"
    }],
    staticClass: "coupon--copy-button",
    attrs: {
      "id": "copy-tooltip-target"
    }
  }, [_c('i', {
    class: _vm.copyIconClass,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-tooltip', {
    ref: "copyTooltip",
    attrs: {
      "target": "copy-tooltip-target",
      "placement": "top"
    }
  }, [_vm._v(" 已複製 ")])], 1) : _vm._e()]), _c('div', {
    staticClass: "coupon--footer"
  }, [_c('div', {
    staticClass: "coupon--line mb-2"
  }), _vm.showConfirmButton ? _c('div', {
    staticClass: "s-mb-6 s-mt-3"
  }, [_vm.couponModel.isRedeemable ? _c('div', {
    staticClass: "coupon-confirm mb-1"
  }, [_vm._v(" 確認使用後將無法復原，請您確認。 ")]) : _vm._e(), _c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": false === _vm.couponModel.isRedeemable
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmButtonText) + " ")])]) : _vm._e(), _vm.showUseButton ? _c('div', {
    staticClass: "s-mb-6 s-mt-3"
  }, [_c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs d-block text-truncate",
    attrs: {
      "type": "button",
      "disabled": false === _vm.couponModel.isRedeemable
    },
    on: {
      "click": _vm.handleUse
    }
  }, [_vm._v(" " + _vm._s(_vm.useButtonText) + " ")])]) : _vm._e(), _vm.displayDescription ? _c('div', {
    staticClass: "s-mb-4 s-px-3 coupon--desc",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayDescription) + " ")]) : _vm._e(), _vm.showQrcodeButton ? _c('div', {
    staticClass: "s-mb-6 s-mt-3"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": false === _vm.couponModel.isRedeemable
    },
    on: {
      "click": _vm.handleQrcodeButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.qrcodeButtonText) + " ")])]) : _vm._e()])]), _c('b-modal', {
    ref: "qrcodeModal",
    attrs: {
      "hide-header": true,
      "hide-footer": true,
      "noCloseOnEsc": true,
      "noCloseOnBackdrop": true
    }
  }, [_c('div', {
    staticClass: "modal-close-button",
    on: {
      "click": function click($event) {
        return _vm.$refs.qrcodeModal.hide();
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32",
      "d": "M368 368L144 144M368 144L144 368"
    }
  })])]), _vm.qrcodeData ? _c('vue-qr', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": _vm.qrcodeData
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }